import React, { useState, useEffect, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import {
    Box,
    IconButton,
    Typography,
    Button
  } from '@mui/material';
  import ZoomInIcon from '@mui/icons-material/ZoomIn';
  import ZoomOutIcon from '@mui/icons-material/ZoomOut';
  import DownloadIcon from '@mui/icons-material/Download';
  import PrintIcon from '@mui/icons-material/Print';
  
// Setup PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const PdfJsViewer = ({ pdfBlob, filename }) => {
  const containerRef = useRef();
  const [scale, setScale] = useState(1.5);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    const renderPDF = async () => {
      if (!pdfBlob || !containerRef.current) return;

      // Clear any previously rendered pages
      containerRef.current.innerHTML = '';

      const arrayBuffer = await pdfBlob.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      setNumPages(pdf.numPages);
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        // Set pixel resolution for rendering (important!)
        if(pageNum < pdf.numPages) {
            canvas.style.borderBottom = '1px solid #ccc';
            canvas.style.marginBottom = '16px';
        }
        canvas.classList.add('pdf-page');
        canvas.width = viewport.width;
        canvas.height = viewport.height;


        // Set visual display size to match rendered size
        canvas.style.width = `${viewport.width}px`;
        canvas.style.height = `${viewport.height}px`;

        const context = canvas.getContext('2d');

        await page.render({
          canvasContext: context,
          viewport,
        }).promise;

        containerRef.current.appendChild(canvas);
      }
    };

    renderPDF();
  }, [pdfBlob, scale]);

  const handlePrint = () => {
    const printWindow = window.open();
    if (printWindow) {
      printWindow.document.write('<html><head><title>Print PDF</title></head><body>');
      const canvases = containerRef.current.querySelectorAll('canvas');
      canvases.forEach((canvas) => {
        const img = canvas.toDataURL('image/png');
        printWindow.document.write(`<img src="${img}" style="width:100%;margin-bottom:20px;" />`);
      });
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };

  const handleDownload = () => {
    if (!pdfBlob) return;
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };


  return (
    <Box sx={{ border: '1px solid #ccc' }}>
    {/* Sticky Toolbar */}
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        px: 2,
        py: 1,
        background: '#fff',
        borderBottom: '1px solid #ccc',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}
    >
      <Box>
        <IconButton onClick={() => setScale((prev) => Math.max(0.5, prev - 0.1))} title="Zoom Out">
          <ZoomOutIcon />
        </IconButton>
        <Typography component="span" sx={{ mx: 1 }}>
          {Math.round(scale * 100)}%
        </Typography>
        <IconButton onClick={() => setScale((prev) => Math.min(3.0, prev + 0.1))} title="Zoom In">
          <ZoomInIcon />
        </IconButton>
      </Box>

      <Box>
        <IconButton onClick={handlePrint} title="Print">
          <PrintIcon />
        </IconButton>
        <IconButton onClick={handleDownload} title="Download PDF">
          <DownloadIcon />
        </IconButton>
      </Box>
    </Box>

    {/* Scrollable Viewer */}
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        height: '80vh',
        overflowY: 'auto',
        paddingRight: '10px',
        scrollPaddingTop: '60px'
      }}
      className="scroll-container"
    />
  </Box>

  );
};

export default PdfJsViewer;

/*    <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '380px',overflowY: 'auto', border: '1px solid #ccc' }} /> */